// extracted by mini-css-extract-plugin
export default {"loadingPlaceholder":"LoadingBlock_loadingPlaceholder__KxFIb","shimmer":"LoadingBlock_shimmer__mgaVY"};